import React, { useEffect, useState } from "react";
import { Logo } from "./Logo";
import { ArrowRight } from "lucide-react";
import WaitlistWizard from "./WaitlistWizard";

const links = [
  { label: "How it works", href: "#how" },
  { label: "App", href: "#app" },
  { label: "Float Pilot", href: "/pilot", highlight: true },
  { label: "FAQ", href: "#faq" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [wizardOpen, setWizardOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#050505]/70 backdrop-blur-xl border-b border-white/5" : "bg-transparent"
      }`}
      data-testid="site-nav"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <a href="#top" className="shrink-0" data-testid="nav-logo-link">
          <Logo />
        </a>
        <nav className="hidden md:flex items-center gap-6">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`text-sm transition-all font-medium ${
                l.highlight
                  ? "text-[#00FF88] hover:text-white relative pl-3 pr-3.5 py-1.5 rounded-full border border-[#00FF88]/40 hover:border-[#00FF88] bg-[#00FF88]/[0.06] hover:bg-[#00FF88]/15 font-bold"
                  : "text-white/60 hover:text-white"
              }`}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.highlight && (
                <span className="absolute -left-0.5 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-[#00FF88] pulse-dot" />
              )}
              {l.label}
            </a>
          ))}
        </nav>
        <button
          type="button"
          onClick={() => setWizardOpen(true)}
          className="group inline-flex items-center gap-2 bg-[#00FF88] text-black font-semibold text-sm px-5 py-2.5 rounded-full btn-glow"
          data-testid="nav-cta-waitlist"
        >
          Join the Waitlist
          <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
        </button>
      </div>
      {/* Mobile-only Float Pilot strip — visible only when desktop nav is hidden */}
      <a
        href="/pilot"
        className="md:hidden flex items-center justify-center gap-2 text-[11px] font-mono-c uppercase tracking-[0.2em] text-[#00FF88] py-2 border-t border-[#00FF88]/15 bg-[#00FF88]/[0.04]"
        data-testid="nav-mobile-pilot"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-[#00FF88] pulse-dot" />
        Apply for the Float Pilot →
      </a>
    </header>
    <WaitlistWizard open={wizardOpen} onClose={() => setWizardOpen(false)} />
    </>
  );
};

export default Nav;
